import { Card, Col } from "reactstrap";
import { JobTodayTitle } from "../../../../../Constants/Constants";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { JobTodayCardBody } from "./JobTodayCardBody";

const JobToday = () => {
  return (
    <Col xl="5" md="6">
      <Card className="job-card">
        <DashboardCommonHeader title={JobTodayTitle} dropdownClass="dropdown-toggle" />
        <JobTodayCardBody/>
      </Card>
    </Col>
  );
};

export default JobToday;
